import { render, staticRenderFns } from "./ReviewBody.vue?vue&type=template&id=3c154210"
import script from "./ReviewBody.vue?vue&type=script&lang=js"
export * from "./ReviewBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports